import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';

interface SignupGateProps {
  isInitialized: boolean;
  isAuthenticated: boolean;
  /** Sends the browser to the Keycloak REGISTRATION form (not the sign in form). */
  onRegister: () => void;
}

/**
 * Entry for the /signup route that marketing sign up buttons link to.
 *
 * Deliberately NOT behind AuthGate: AuthGate calls login() for any guest, which
 * lands a new visitor on the sign in form. Here a guest goes straight to the
 * registration form, and someone who is already signed in goes to the app.
 * Until auth has initialised (and while the redirect to Keycloak is in
 * flight) it shows the same neutral fullscreen spinner AuthGate uses.
 */
export function SignupGate({ isInitialized, isAuthenticated, onRegister }: SignupGateProps) {
  useEffect(() => {
    if (isInitialized && !isAuthenticated) {
      onRegister();
    }
  }, [isInitialized, isAuthenticated, onRegister]);

  if (isInitialized && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <LoadingSpinner fullscreen />;
}
